/** RibbonTrailMesh resource slice: claims the type name. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('ribbontrailmesh', ['RibbonTrailMesh']);
//# sourceMappingURL=index.js.map